import type { SVGProps } from 'react';

const SvgReorder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M16 14h-2c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2m0 4h-2v-2h2zm3-13h-2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2M9 17c-2.21 0-4-1.79-4-4s1.79-4 4-4h.59L8.3 10.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l3-3a.996.996 0 0 0 0-1.41l-3-3A.996.996 0 1 0 8.31 5.7L9.6 6.99h-.59c-3.31 0-6 2.69-6 6s2.69 6 6 6c.55 0 1-.45 1-1s-.45-1-1-1z"
    />
  </svg>
);
export default SvgReorder;
